import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const CreativeBloq: Site = {
  id: 'creativebloq',
  logo: 'svg/creativebloq.svg',
  label: 'Creative Bloq',
  analyticsName: 'cbq',
  hostname: 'creativebloq.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
